export const environment = {
  production: false,
  environmentName: 'staging',
  carmovaApiUrl: 'https://carmova-api-staging-2e4g646uda-ew.a.run.app',
  sentryDsn:
    'https://a4fe0e33952c017a218d52d9c9eda335@o1097620.ingest.us.sentry.io/4506982529892353',
  sentryEnabled: false,
  enableServiceWorker: true,
  transactionMinPicture: 1,
  movacarProUrl: 'https://staging.movacarpro.com/',
  vehicleInspectionUrl:
    'https://vehicle-inspection-staging-2e4g646uda-ew.a.run.app',
  vehicleInspectionClientKey: 'jKE5nz6vnbTb0qlp',
  vehicleInspectionClientSecret: 'foo',
  vehicleInspectionStandardLegalText: 'movacarpro_pdf_disclaimer_text',
  vehicleInspectionStandardLanguage: 'de',
  dropoffTimeBuffer: 1,
  firebaseConfig: {
    apiKey: 'AIzaSyCTCtmKyBqiMNUBn84UzeRoIhq_PKO-cP0',
    authDomain: 'carmova.firebaseapp.com',
    projectId: 'carmova',
    storageBucket: 'carmova.firebasestorage.app',
    messagingSenderId: '480117496117',
    appId: '1:480117496117:web:537199eb61136fcfea147c',
    measurementId: 'G-NPR7BPE3H6',
  },
  monkeyPdfConfig: {
    createMonkeyPdfUrl: 'https://api.pdfmonkey.io/api/v1/documents',
    downloadMonkeyPdfUrl: 'https://api.pdfmonkey.io/api/v1/document_cards',
    templateId: 'B4F1D8CC-E1AD-4BE5-87A0-41AF164100FE',
  },
  zoho: {
    salesIQ: {
      ios: {
        appKey:
          'nyPRcpxHd4gXznosJGJZ5MBPaaa42QEIBeGeNOwqIzc%2FV%2BBw7jD5uqFM8qYyYmg%2F_eu',
        accessKey:
          'eNeAjMiuSCF9Qg5GRscSNbJl8hu8Pw4MLPVri1Fn%2B3WWDiVRXgLm%2BzpUu08dGZpdxCbQkgjkKpNk42vOb9TBXIAAOeSew%2B7VVFKCVBv1iRJN2kFqlWx1ZCPwVNbg7ejK',
      },
      android: {
        appKey:
          'nyPRcpxHd4gXznosJGJZ5MBPaaa42QEIBeGeNOwqIzc%2FV%2BBw7jD5uqFM8qYyYmg%2F_eu',
        accessKey:
          'eNeAjMiuSCFJvf%2Ftsm3zHh1lgY6TDGBH09QgngWzuEgUqLPpNaIjuDlQ5XPfzMFeCsTqTjZ6oPOzqs4doyJ58P3ps9DFP8Hp2tAvbhP9%2B5z8VPL%2B%2BNpEVDVN9U4EIJ5e',
      },
    },
  },
  salesforceUrl:
    'https://movacar--uat.sandbox.my.salesforce-sites.com/services/apexrest',
  translationUrl:
    'https://translation-service-staging-480117496117.europe-west1.run.app',
  n8nWebhookUrl: 'https://movacar.app.n8n.cloud/webhook/',
  n8nVerificationResult: '6f3c762f-0da7-4c03-88c8-f024bb858cd0',
  n8nVerificationSuccess: '7360be34-b3d5-4b0f-841b-8468fb9caf9d',
  n8nRefreshToken: '8fac47c1-2d52-4946-acf1-3ac7a26530f5',
  n8nErrorNotification: 'e2c1e150-fe71-42f2-b62f-eba07869236a',
  registrationTypeformId: 'VtXYKjpV',
  moEngage: {
    enableDebugLogs: false,
    appId: 'U9YKPVBQ9O55ORVYGV6JL274',
  },
};
